/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { BlockKitContext } from './BlockKitContext.js';
import {
    BlockKitContextFromJSON,
    BlockKitContextFromJSONTyped,
    BlockKitContextToJSON,
} from './BlockKitContext.js';

/**
 * 
 * @export
 * @interface CreateCommandExecutionRequest
 */
export interface CreateCommandExecutionRequest {
    /**
     * 
     * @type {BlockKitContext}
     * @memberof CreateCommandExecutionRequest
     */
    context?: BlockKitContext;
    /**
     * 
     * @type {string}
     * @memberof CreateCommandExecutionRequest
     */
    commandId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateCommandExecutionRequest
     */
    data?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateCommandExecutionRequest interface.
 */
export function instanceOfCreateCommandExecutionRequest(value: object): boolean {
    return true;
}

export function CreateCommandExecutionRequestFromJSON(json: any): CreateCommandExecutionRequest {
    return CreateCommandExecutionRequestFromJSONTyped(json, false);
}

export function CreateCommandExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommandExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'context': json['context'] == null ? undefined : BlockKitContextFromJSON(json['context']),
        'commandId': json['commandId'] == null ? undefined : json['commandId'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function CreateCommandExecutionRequestToJSON(value?: CreateCommandExecutionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'context': BlockKitContextToJSON(value['context']),
        'commandId': value['commandId'],
        'data': value['data'],
    };
}

